import React from 'react';
import { Typography, Box } from '@mui/material';
import { Announcement, CalendarMonth } from '@mui/icons-material';
import "../../styles/bulletin/bulletin.scss";

const BulletinPage = () => {
  const announcements = [
    {
      title: "PIVOT Launch",
      date: "April 7, 2025",
      type: "system",
      content: "The PIVOT system will be deployed on April 7, 2025. This new platform developed by ICTDO will streamline document processing and improve communication across departments. You may use this system to file your Travel Requests and COS. We encourage all users to familiarize themselves with the features and provide feedback during the initial launch phase."
    },
    {
      title: "March COS",
      date: "April 10, 2025",
      type: "deadline",
      content: "All Certificate of Service(COS) must be submitted by this date to ensure timely processing. Late submissions may result in delayed processing and disbursement. Please ensure all required documentation is complete and accurate before submission."
    },
  ];

  return (
    <div className="bulletin-page">
      <div className="page-header">
        <Announcement className="header-icon" />
        <Typography variant="h4">UPOU Bulletin</Typography>
      </div>
      <div className="announcements-list">
        {announcements.map((announcement, index) => (
          <div key={index} className="announcement-item" style={{ animationDelay: `${index * 0.1}s` }}>
            <Typography variant="h6" className="announcement-title">
              {announcement.title}
            </Typography>
            <Typography variant="body2" className="announcement-date">
              <CalendarMonth sx={{ fontSize: '1rem', marginRight: '4px' }} />
              {announcement.date}
            </Typography>
            <Typography variant="body1" className="announcement-content">
              {announcement.content}
            </Typography>
            <Typography 
              variant="body1" 
              className="announcement-type"
              data-type={announcement.type}
            >
              {announcement.type.charAt(0).toUpperCase() + announcement.type.slice(1)}
            </Typography>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BulletinPage; 